module.exports = __webpack_public_path__ + "static/media/ic_toggle.bc197966.svg";